<template>
  <tr>
    <td>
      <v-tooltip right>
        <v-btn flat icon small :loading="loading" slot="activator" @click.prevent="pdfJuramento(juramento.id)">
          <v-icon color="red">picture_as_pdf</v-icon>
        </v-btn>
         <span>Ver Lista de Abogados Habilitados</span>
      </v-tooltip>
      <v-tooltip right v-if="juramento.fotosJuramento.length>0">
        <v-btn flat icon small slot="activator" @click="mostrarFotos(juramento)">
          <v-icon color="primary lighten-3">photo_library</v-icon>
        </v-btn>
        <span>Ver Fotos Juramento</span>
      </v-tooltip>
    </td>
    <td class="text-xs-left">{{juramento.nombre}}</td>
    <td class="text-xs-left">{{juramento.lugarJuramento}}</td>
    <td class="text-xs-left">{{formatDateJuramento(juramento.fechaHora)}}</td>
    <td class="text-xs-left">{{juramento.cantidad}}</td>
  </tr>
</template>
<script>
export default {
  props: {
    juramento: {
      id: null,
      nombre: null,
      lugarJuramento: null,
      fechaHora: null,
      fechaPublicacion: null,
      fotosJuramento: null
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    formatDateJuramento(date) {
      if (!date) return null;
      const [dates, hours] = date.split(" ");
      if (date.indexOf("-") > 0) {
        const [year, month, day] = dates.split("-");
        return `${day}/${month}/${year}`;
      }
      return date;
    },
    pdfJuramento(id) {
      this.isLoading = true;
      this.loading = true;
      this.$http
        .get(`${this.$apiUrl}publico/juramento/${id}`)
        .then(response => {
          let fileType = "application/pdf";
          let name = `${response.data.data.titulo}.pdf`;
          let a = document.createElement("a");
          a.download = name;
          a.href = window.URL.createObjectURL(
            this.b64toBlob(response.data.data.pdf, "application/pdf")
          );
          window.open(a.href,'_blank');
          this.isLoading = false;
          //a.dataset.downloadurl = [fileType, a.download, a.href].join(":");
          a.style.display = "none";
          document.body.appendChild(a);
          this.loading = false;
          //a.click();
          document.body.removeChild(a);
          setTimeout(() => {
            URL.revokeObjectURL(a.href);
          }, 1500);
        })
        .catch(error => {
          this.loading = false;
          this.isLoading = false;
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;
      let byteCharacters = atob(b64Data);
      let byteArrays = [];
      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    mostrarFotos(data){
      this.$emit("mostrarFotos",data);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Juramento/RegistroJuramento.vue